// Keyed by exact source URL. Add new entries here to redirect any locale.
const REDIRECT_MAP = {
  'https://mylook.acuvue.com/jp/#/home':
    'https://www.acuvue.com/ja-jp/mylook-vm/',
  'https://mylook.acuvue.com/jp/#/vm':
    'https://www.acuvue.com/ja-jp/mylook-vm/',
  'https://mylook.acuvue.com/jp/#/quiz':
    'https://www.acuvue.com/ja-jp/mylook-vm/',
};

export function getRedirectTarget(currentUrl) {
  const normalizedUrl = currentUrl.replace(/(#\/[^?]*?)\/$/, '$1');
  return REDIRECT_MAP[normalizedUrl] || null;
}
